<div class="background" [ngStyle]="{'background-image': 'url(' + '/assets/backgrounds/' + gameService.backgroundUrl + ')'}">
  <div
    *ngIf="!justBackground"
    [style]="{
      background: 'url(' + '/assets/backgrounds/' + gameService.frameBackgroundUrl + ') repeat',
      top: marginTop + 'px',
    }"
    class="frame"
  >
    <img *ngIf="!koffer" alt="lights" class="lights" src="/assets/backgrounds/lights.svg" />
    <button (click)="toggleShowKoffer()" *ngIf="koffer" class="reset">
      <img
        [src]="'/assets/img/' + kofferImg"
        alt="koffer"
        class="koffer"
      />
    </button>

    <app-human-text-cloud
      *ngIf="gameService.showRequestEndDateOnSecondDay && !koffer && gameService.dontShowSecondDayEndDateRequest && !endDate"
      [showEndDateButtons]="true"
      [text]="general?.requestStartDateText"
    >
    </app-human-text-cloud>

    <app-human-text-cloud
      *ngIf="gameService.showEndDateRequest && !koffer && !firstLogin"
      [showEndDateButtons]="true"
      [text]="general?.requestStartDateText"
    >
    </app-human-text-cloud>

    <app-human-text-cloud
      *ngIf="
        gameService.showWelcomeMessage &&
        filterDataService.currentlyShowingMissions.value.length !== 0 &&
        !koffer &&
        !firstLogin &&
        !gameService.showEndDateRequest &&
        !gameService.showRequestEndDateOnSecondDay
      "
      [feedbackButtonText]="welcomeText.feedbackButtonText"
      [showEndDateButtons]="false"
      [showFeedbackButton]="welcomeText.isFeedbackRequest"
      [showGoToMissionsButton]="!welcomeText.feedbackButtonText"
      [text]="welcomeText.contents"
    />

    <app-human-text-cloud
      *ngIf="
        !gameService.showEndDateRequest &&
        !koffer &&
        filterDataService.currentlyShowingMissions.value.length === 0 &&
        !contentService.isLoading
      "
      [showEndDateButtons]="false"
      [showGoToMissionsButton]="false"
      [text]="finishedMissionsText"
    >
    </app-human-text-cloud>

    <button (click)="gameService.turnOffFirstLoginCloudText()" class="reset">
      <app-human-text-cloud
        *ngIf="firstLogin && this.gameService.showWelcomeMessage && !koffer"
        [showEndDateButtons]="false"
        [showGoToMissionsButton]="true"
        [text]="general?.firstWelcomeText"
      >
      </app-human-text-cloud>
    </button>

    <div *ngIf="!gameService.showWelcomeMessage && !koffer && !gameService.showEndDateRequest" class="missions">
      <ng-container *ngFor="let mission of currentlyShowingMissions">
        <app-mission-card [missionData]="mission" [routerLink]="'mission/' + mission?.id"></app-mission-card>
      </ng-container>
    </div>
    <div *ngIf="koffer && !kofferOpened" class="amount-finished-missions">
      <img alt="" class="levels-outline" src="/assets/img/levels-outline.svg" />
      <div class="count">
        <div class="chart">
          <div
            *ngIf="filterDataService.finishedMission?.value?.length > 0"
            [style]="{ transform: 'rotate(' + (kofferCompletion * 162 + 10) + 'deg)' }"
          >
            <span class="candidate-one-percentage"></span>
            <span class="candidate-two-percentage"></span>
          </div>

          <div *ngIf="filterDataService.finishedMission?.value?.length === 0" [style]="{ transform: 'rotate(15deg)' }">
            <span class="candidate-one-percentage"></span>
            <span class="candidate-two-percentage"></span>
          </div>
        </div>
      </div>
      <div class="count-text">
        {{ filterDataService.finishedMission.value.length > 0 ? filterDataService.finishedMission.value.length : 0 }}
        / {{ gameService.missionsToUpgrade.value ? gameService.missionsToUpgrade.value : 0 }}
      </div>
      <div *ngIf="koffer && !kofferOpened" class="pointer">
        <img
          *ngIf="filterDataService.finishedMission?.value?.length > 0"
          [style]="{ transform: 'rotate(' + (this.kofferCompletion * 167 - 83.5) + 'deg)' }"
          alt=""
          src="/assets/img/pointer-arrow.svg"
        />
        <img
          *ngIf="filterDataService.finishedMission?.value?.length === 0"
          [style]="{ transform: 'rotate(-75deg)' }"
          alt=""
          src="/assets/img/pointer-arrow.svg"
        />
      </div>
    </div>

    <div>
      <div *ngIf="koffer && kofferOpened && filterDataService.finishedMission.value.length > 0" class="koffer-missions missions">
        <ng-container *ngFor="let mission of finishedMissionsData">
          <app-mission-card [isChecked]="true" [missionData]="mission" [routerLink]="'../mission/' + mission?.id"></app-mission-card>
        </ng-container>
      </div>
      <div *ngIf="koffer && kofferOpened && filterDataService.finishedMission.value.length > 0" class="double-arrow-down">
        <img alt="arrow down" src="/assets/icons/double-arrow-down.svg" />
      </div>
    </div>
  </div>
  <div *ngIf="canSkipDay" class="skip-day buttons">
    <button (click)="skipDay()" class="">Volgende dag</button>
  </div>
  <div *ngIf="koffer" class="open-koffer-button">
    <button (click)="toggleShowKoffer()" class="main-button">{{ kofferOpened ? 'Sluit' : 'Open' }}</button>
  </div>
</div>
